import { useAtom, useAtomValue } from 'jotai';
import { useCallback } from 'react';

import { temporaryCartKeyAtom } from '$business/atoms/cart-key';

export function useTemporaryCartKeyAtom() {
  const [cartkey, setCartkey] = useAtom(temporaryCartKeyAtom);

  const onCartKeyChange = useCallback((nextCartKey?: string) => {
    setCartkey(nextCartKey);
  }, [setCartkey]);

  const onCartKeyClear = useCallback(() => {
    setCartkey(undefined);
  }, [setCartkey]);

  return { cartkey, onCartKeyChange, onCartKeyClear };
}

export function useROCartKeyAtom() {
  return useAtomValue(temporaryCartKeyAtom);
}
